import { render, staticRenderFns } from "./PatternsPage.vue?vue&type=template&id=546154e4&scoped=true&"
var script = {}
import style0 from "./PatternsPage.vue?vue&type=style&index=0&id=546154e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546154e4",
  null
  
)

export default component.exports